import { Suspense, lazy, useEffect } from "react";
import { AppProvider, useApp } from "./context/AppContext";
import Landing from "./screens/Landing";

// All other screens are lazy-loaded — only downloaded when user navigates there
const YourJourney = lazy(() => import("./screens/YourJourney"));
const StepNudge = lazy(() => import("./screens/StepNudge"));
const CollectName = lazy(() => import("./screens/CollectName"));
const Quiz = lazy(() => import("./screens/Quiz"));
const GoogleSignIn = lazy(() => import("./screens/GoogleSignIn"));
const FreeResults = lazy(() => import("./screens/FreeResults"));
const Upgrade = lazy(() => import("./screens/Upgrade"));
const Purchase = lazy(() => import("./screens/Purchase"));
const PaidReport = lazy(() => import("./screens/PaidReport"));
const Methodology = lazy(() => import("./screens/Methodology"));
const AdminLogin = lazy(() => import("./screens/AdminLogin"));
const Admin = lazy(() => import("./screens/Admin"));

// Auth-required screens that should wait for auth state before rendering
const AUTH_SCREENS = ["your-journey", "paid-report", "admin"];

function Spinner() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "linear-gradient(160deg, #0c3078 0%, #071d52 100%)" }}>
      <span className="mm-spinner" />
    </div>
  );
}

function AppRouter() {
  const { screen, setScreen, authLoading } = useApp();

  // Admin keyboard shortcut - Ctrl+Shift+A
  useEffect(() => {
    const handleAdminKey = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "A") setScreen("admin-login");
    };
    window.addEventListener("keydown", handleAdminKey);
    return () => window.removeEventListener("keydown", handleAdminKey);
  }, [setScreen]);

  // Only block rendering for auth-required screens — landing page renders immediately
  if (authLoading && AUTH_SCREENS.includes(screen)) return <Spinner />;

  return (
    <Suspense fallback={<Spinner />}>
      {screen === "landing" && <Landing />}
      {screen === "your-journey" && <YourJourney />}
      {screen === "step-nudge" && <StepNudge />}
      {screen === "collect-name" && <CollectName />}
      {screen === "test" && <Quiz />}
      {screen === "google-signin" && <GoogleSignIn />}
      {screen === "free-results" && <FreeResults />}
      {screen === "upgrade" && <Upgrade />}
      {screen === "purchase" && <Purchase />}
      {screen === "paid-report" && <PaidReport />}
      {screen === "methodology" && <Methodology />}
      {screen === "admin-login" && <AdminLogin />}
      {screen === "admin" && <Admin />}
      {!["landing","your-journey","step-nudge","collect-name","test","google-signin","free-results","upgrade","purchase","paid-report","methodology","admin-login","admin"].includes(screen) && <Landing />}
    </Suspense>
  );
}

export default function MirrorMirror() {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
}
